const openEnded = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "open-ended",
    items: [
      { id: "q1", question: "O texto do prompt 1", answers: [], image: null },
      { id: "q2", question: "O texto do prompt 2", answers: [], image: null },
      { id: "q3", question: "O texto do prompt 3", answers: [], image: null },
      { id: "q4", question: "O texto do prompt 4", answers: [], image: null },
      { id: "q5", question: "O texto do prompt 5", answers: [], image: null },
    ],
  },
  botId: "nualang.open-ended.0.0.1",
  botName: "open_ended",
  description: "open_ended_desc",
  difficulty: "ALL",
  learnLang: "portuguese",
  name: "",
  botAvatar: "",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-comment-dots?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Bem-vindo

   
  Diga "Olá" a bot para começar.`,
  voice: "",
  versionQuestion: "Quantas perguntas você gostaria neste modelo?",
};

export default openEnded;
